'use client';

import React from 'react';

// ─── SERENA WILLIAMS DESIGN CREW 3D ──────────────────────────────────────────
// Source: https://www.behance.net/gallery/215673297/Serena-Willams-Design-Crew-3DDesign
// All images extracted directly from the live Behance gallery
// Gallery ID: 215673297 — Abdullah Quick

// ── ACTUAL GALLERY IMAGES FROM BEHANCE 215673297 ──
// These are the real images from the Serena Williams Design Crew 3D project
const SWDC_IMAGES = [
  // Hero / cover image
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/98ac54215673297.6787cfe4c18ff.jpg',
  // Second full-width image
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/a62f95215673297.6787cfe4c11f7.jpg',
  // Grid images
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/e4fb2a215673297.6787cfe4c3101.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/eb26d4215673297.6787cfe4c21ce.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/260669215673297.6787cfe4c297a.jpg',
  // Portrait / tall image
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/f6f795215673297.6771574875409.jpg',
  // PNG assets
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/49b36c215673297.6771574bc7bf9.png',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/6618c4215673297.6771574bc6dfe.png',
  // Video stills / renders
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200_webp/98e40e215673297.677319d90c4e5.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200_webp/f4c0cf215673297.677319d90cc3e.jpg',
  // More PNGs
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/c49fdb215673297.6771574bc4558.png',
  // Large renders
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/a4151e215673297.6771574a14e33.png',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/85c4c1215673297.6771574a13494.png',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/54a397215673297.6771574a14606.png',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/7fbe5a215673297.6771574a13cb8.png',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/8d9036215673297.6771574a15398.png',
  // Portrait renders
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/d73597215673297.6771574916b5c.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/4befac215673297.67715749173d4.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/b64903215673297.67715749164d2.jpg',
  // Additional images
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/8d584a215673297.677fd28eaac7c.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/8e9c28215673297.677fc2c89636d.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/08bac6215673297.677fd28eab58f.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/4c7e76215673297.6771574bc5c34.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/23d547215673297.6771574bc5734.jpg',
];

// ── GIF ANIMATIONS ──
const SWDC_GIFS = [
  'https://mir-s3-cdn-cf.behance.net/project_modules/source/061c76215673297.677f329656fe3.gif',
  'https://mir-s3-cdn-cf.behance.net/project_modules/source/885500215673297.677edad4e4e31.gif',
  'https://mir-s3-cdn-cf.behance.net/project_modules/source/e6192d215673297.677edad4e473c.gif',
  'https://mir-s3-cdn-cf.behance.net/project_modules/source/e01264215673297.677edbcdb094b.gif',
  'https://mir-s3-cdn-cf.behance.net/project_modules/source/08431f215673297.677ed7ade7cc0.gif',
  'https://mir-s3-cdn-cf.behance.net/project_modules/source/3125cc215673297.677ed7ade8285.gif',
  'https://mir-s3-cdn-cf.behance.net/project_modules/source/85944d215673297.677ed8653889c.gif',
];

// ── ADDITIONAL IMAGES ──
const SWDC_EXTRA = [
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/1ba359215673297.677f3d06bf914.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/af88eb215673297.677fff5167f24.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/085616215673297.677ffe974b627.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200_webp/26f3e8215673297.677f32965687f.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/c3ecdf215673297.677f675cc624d.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200_webp/b545bb215673297.678001736dfec.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/2b2d71215673297.677f1b20f2d64.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/eb14a9215673297.677e2135ae459.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/9f0fcf215673297.677e2135adc5b.jpg',
];

// ── SNEAKER / PRODUCT IMAGES ──
const SWDC_PRODUCTS = [
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400/0a15fb215673297.69c8b3ca4db23.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400/aacd99215673297.69c8b3ca4d550.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400/509e20215673297.69c8b3ca4c94e.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400/56820a215673297.69c8b3ca4cf6f.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200_webp/aef7fe215673297.69c8b3cabaf3b.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200_webp/a56516215673297.69c8b3cb1a017.jpeg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200_webp/9151f4215673297.69c8b3cb19a0f.jpeg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/hd_webp/31982e215673297.69c8b3cd04c87.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/98aef1215673297.69c8b3cd04926.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/hd_webp/97979d215673297.69c8b3cd044e1.jpeg',
];

export default function SerenaWilliamsSection() {
  return (
    <section id="serena-williams" style={{ backgroundColor: '#fff' }}>
      {/* ════════════════════════════════════════════════════════════════════════
           ── CHAPTER BREAK: SERENA WILLIAMS DESIGN CREW 3D ──
           ════════════════════════════════════════════════════════════════════════ */}
      <div style={{
        background: '#fff',
        padding: '60px 7.1% 40px',
        textAlign: 'center',
        borderTop: '1px solid #e8e8e8',
      }}>
        <div style={{
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 10,
          letterSpacing: '.25em',
          textTransform: 'uppercase',
          color: '#a4a4a4',
          marginBottom: 16,
        }}>
          This is a multi-stage journey. These were the previous stages:
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 24, flexWrap: 'wrap', marginBottom: 32 }}>
          {["25' Photographs", "25' Graphics", "25' 3D", "25' Enviorments", "25' Patterns"]?.map((stage) => (
            <span key={stage} style={{
              fontFamily: 'helvetica, arial, sans-serif',
              fontSize: 14,
              color: '#1769FF',
              textDecoration: 'underline',
              cursor: 'default',
            }}>
              {stage}
            </span>
          ))}
        </div>
      </div>
      {/* ── HERO IMAGE — Nike Design Announcement ── */}
      <div style={{ marginBottom: 4 }}>
        <img
          src={SWDC_IMAGES?.[0]}
          alt="Serena Williams Design Crew 3D — Nike Design announcement, designer in colorful jacket"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
      {/* ── SECOND FULL-WIDTH IMAGE ── */}
      <div style={{ marginBottom: 4 }}>
        <img
          src={SWDC_IMAGES?.[1]}
          alt="Serena Williams Design Crew 3D — design work"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
      {/* ── 3-UP GRID ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_IMAGES?.slice(2, 5)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC 3D design ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── TALL PORTRAIT IMAGE ── */}
      <div style={{ marginBottom: 4 }}>
        <img
          src={SWDC_IMAGES?.[5]}
          alt="Serena Williams Design Crew 3D — portrait render"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
      {/* ── 2-UP PNG ASSETS ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_IMAGES?.slice(6, 8)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC design asset ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── 3D MODELING SCREENSHOTS ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_IMAGES?.slice(8, 10)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC 3D modeling workflow ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── FULL WIDTH PNG ── */}
      <div style={{ marginBottom: 4 }}>
        <img
          src={SWDC_IMAGES?.[10]}
          alt="Serena Williams Design Crew 3D — design asset"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
      {/* ── 5-UP RENDER GRID ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_IMAGES?.slice(11, 16)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC render ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── 3-UP PORTRAIT RENDERS ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_IMAGES?.slice(16, 19)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC portrait render ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── ADDITIONAL IMAGES ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_IMAGES?.slice(19, 22)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC additional ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── 2-UP IMAGES ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_IMAGES?.slice(22, 24)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC design ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── GIF ANIMATIONS ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_GIFS?.slice(0, 3)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC animation ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── MORE GIF ANIMATIONS ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_GIFS?.slice(3)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC motion study ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── EXTRA IMAGES ── */}
      <div style={{ marginBottom: 4 }}>
        <img
          src={SWDC_EXTRA?.[0]}
          alt="SWDC design work"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_EXTRA?.slice(1, 3)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC extra ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_EXTRA?.slice(3, 6)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC work ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_EXTRA?.slice(6)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC design ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── SNEAKER / PRODUCT DESIGNS ── */}
      {/* Full width product hero */}
      <div style={{ marginBottom: 4 }}>
        <img
          src={SWDC_PRODUCTS?.[0]}
          alt="SWDC Nike sneaker design — product render"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_PRODUCTS?.slice(1, 4)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`Nike sneaker design ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      <div style={{ marginBottom: 4 }}>
        <img
          src={SWDC_PRODUCTS?.[4]}
          alt="SWDC Nike sneaker — full lineup"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 4 }}>
        {SWDC_PRODUCTS?.slice(5, 7)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`Nike product ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 40 }}>
        {SWDC_PRODUCTS?.slice(7)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`SWDC product render ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── CHAPTER TITLE BLOCK ── */}
      <div style={{
        background: '#fff',
        padding: '40px 7.1%',
        textAlign: 'center',
        borderTop: '1px solid #e8e8e8',
        borderBottom: '1px solid #e8e8e8',
        marginBottom: 0,
      }}>
        <div style={{
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 10,
          letterSpacing: '.25em',
          textTransform: 'uppercase',
          color: '#a4a4a4',
          marginBottom: 12,
        }}>
          Product Design · Art Direction · Fashion
        </div>
        <h2 style={{
          color: '#191919',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 'clamp(24px, 4vw, 36px)',
          fontWeight: 700,
          margin: '0 0 12px',
          letterSpacing: '.01em',
          lineHeight: 1.1,
        }}>
          Serena Willams Design Crew: 3D Design
        </h2>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 14,
          fontWeight: 400,
          letterSpacing: '.04em',
          marginBottom: 20,
        }}>
          Nike SWDC Apprenticeship · 2024
        </div>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 15,
          fontWeight: 400,
          lineHeight: '1.7em',
          maxWidth: 680,
          margin: '0 auto 20px',
        }}>
          3D design work created in collaboration with the Serena Williams Design Crew apprenticeship program — a Nike initiative providing emerging designers from diverse backgrounds a platform to develop their craft and bring their vision to sport style.
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap' }}>
          {['design', '3D', 'product design', 'ILLUSTRATION', 'Digital Art', 'concept', 'artwork', 'portfolio']?.map(tag => (
            <span key={tag} style={{
              fontFamily: 'helvetica, arial, sans-serif',
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: '.08em',
              textTransform: 'uppercase',
              color: '#959595',
              border: '1px solid #ccc',
              borderRadius: 3,
              padding: '5px 10px',
            }}>
              {tag}
            </span>
          ))}
        </div>
        <div style={{ marginTop: 24 }}>
          <a
            href="https://www.behance.net/gallery/215673297/Serena-Willams-Design-Crew-3DDesign"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              fontFamily: 'helvetica, arial, sans-serif',
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: '.08em',
              color: '#1769FF',
              textDecoration: 'none',
            }}
          >
            View on Behance →
          </a>
        </div>
      </div>
    </section>
  );
}
